import { render, staticRenderFns } from "./CommunicationComposeModal.vue?vue&type=template&id=e591a11a&"
import script from "./CommunicationComposeModal.vue?vue&type=script&lang=js&"
export * from "./CommunicationComposeModal.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationComposeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports